import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

class StoreErrorBoundary extends React.Component {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  componentDidCatch(error) { window.fbdBootReady?.(); console.error('FBD storefront failed', error); }
  render() {
    return this.state.failed ? <main role="alert" className="max-w-lg mx-auto p-6 mt-16 space-y-4"><h1 className="text-xl font-bold">This page could not load</h1><p>Please reload and try again.</p><button className="border rounded p-3" onClick={() => window.location.reload()}>Reload page</button></main> : this.props.children;
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <StoreErrorBoundary><App /></StoreErrorBoundary>
    </QueryClientProvider>
  </React.StrictMode>,
);
